import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import store from "./state/store";

import VueCookies from "vue-cookies";
Vue.use(VueCookies);
VueCookies.config("7d");

import webpage_header from "@/components/header";
Vue.component("webpage_header", webpage_header);

import webpage_nav from "@/components/navigation";
Vue.component("webpage_nav", webpage_nav);

Vue.config.productionTip = false;

Vue.prototype.$webpageEventBus = new Vue();

require("moment/locale/bs");

// SABIRA icon
// import sabira_icon from "@/components/sabira_icon";
// Vue.use(sabira_icon);
import sabira_icon from "@/components/sabira_icon";
Vue.component("sabira_icon", sabira_icon);

// SABIRA email
import sabira_email from "@/components/email";
Vue.component("sabira_email", sabira_email);

// Tooltips
import sabira_tooltip from "@/components/sabira_tooltip";
Vue.component("sabira_tooltip", sabira_tooltip);
import sabira_left_tooltip from "@/components/sabira_left_tooltip";
Vue.component("sabira_left_tooltip", sabira_left_tooltip);
import sabira_right_tooltip from "@/components/sabira_right_tooltip";
Vue.component("sabira_right_tooltip", sabira_right_tooltip);
import sabira_tooltip_bottom from "@/components/sabira_tooltip_bottom";
Vue.component("sabira_tooltip_bottom", sabira_tooltip_bottom);

// AXIOS
import axios from "axios";

// masonry
import VueMasonry from "vue-masonry-css";
Vue.use(VueMasonry);

import i18n from "./i18n";
import NumberFormatter from './numberFormatter';

Vue.filter('n', (value) => NumberFormatter.shared.n(value));
Vue.prototype.$n = (value) => NumberFormatter.shared.n(value);

axios.defaults.baseURL = process.env.VUE_BASE_URL;
Vue.prototype.$http = axios;
//Vue.use(axios);
Vue.prototype.$chart_colors = [
  "#195391", // Deep Blue (Primary)
  "#28A745", // Emerald Green (Success)
  "#FFC107", // Golden Amber (Warning)
  "#17A2B8", // Steel Teal (Modern Accent)
  "#8491D3", // Lavender Blue (Calm, secondary data)
  "#3BA272", // Forest Green (Sustainability, growth)
  "#FC8452", // Warm Coral (Balanced attention, not overwhelming)
  "#9A60B4", // Royal Purple (Luxury, significance)
  "#EA7CCC", // Soft Pink (Subtle contrast for lighter themes)
];

const moment = require("moment");

import helpers from "./helpers";
const helpers_plugin = {
  install() {
    Vue.helpers = helpers;
    Vue.prototype.$helpers = helpers;
  },
};
Vue.use(helpers_plugin);
Vue.use(require("vue-moment"), {
  moment,
});

new Vue({
  router,
  vuetify,
  store,
  i18n,
  axios,
  render: (h) => h(App),
}).$mount("#app");